import _ from 'underscore'
import Vue from 'vue'
import live from '@/live'
import api from '@/api'

export default {

	namespaced: true,

	state: {
		data: {
			texts: []
		}
	},

	getters: {

		all: function(state) {

			return _.sortBy(state.data.texts, function(item) {

				return item.title.toLowerCase()

			})

		},

		find: function(state) {

			return function(id) {

				return _.findWhere(state.data.texts, {
					id: parseInt(id)
				})

			}

		},

		'find/index': function(state) {

			return function(index) {

				var texts = []

				_.each(index, function(id) {

					var text = _.findWhere(state.data.texts, {
						id: parseInt(id)
					})

					if (text) texts.push(text)
						
				})

				return texts

			}

		}

	},

	mutations: {

		set: function(state, data) {

			state.data.texts = data.texts

		},

		update: function(state, data) {

			var index = _.findIndex(state.data.texts, {
				id: data.id
			})

			if (index !== -1) {
				
				Vue.set(state.data.texts, index, data)

			} else {

				state.data.texts.push(data)

			}

		},

		delete: function(state, data) {

			var index = _.findIndex(state.data.texts, {
				id: data.id
			})

			if (index !== -1) state.data.texts.splice(index, 1)

		}

	},

	actions: {

		init: function(context, data) {

			context.commit('set', data)

			live.$on('text/add', function(params) {

				context.commit('update', params)

			})

			live.$on('text/update', function(params) {

				context.commit('update', params)

			})

			live.$on('text/delete', function(params) {

				context.commit('delete', params)

			})

		},

		save: function(context, data) {

			return (data.id) ? api.put('text/' + data.id, data) : api.post('text', data)

		},

		delete: function(context, data) {

			return api.delete('text/' + data.id, data)

		}

	}

}
